<template>
  <div>
    <create
      @closePopup="createDialog = false"
      @createData="create($event)"
      @getShcools="getSchoolIems($event)"
      :schoolItems="schoolItems"
      :dialog="createDialog"
      :loader="createLoader"
    />
    <edit
      @closePopup="editDialog = false"
      @editData="edit($event)"
      @getShcools="getSchoolIems($event)"
      :schoolItems="schoolItems"
      :dialog="editDialog"
      :dialogData="dialogData"
      :loader="showLoader"
    />
    <delete-popup
      @closePopup="deleteDialog = false"
      @deleteData="deleteItem($event)"
      :dialog="deleteDialog"
      :item="deleteDialogData"
      :loader="deleteLoader"
    />
    <v-row class="mb-4">
      <v-col class="d-flex justify-end"
        ><v-btn color="primary" @click="createAble"
          ><span style="color: white;">{{ $t("add") }}</span></v-btn
        ></v-col
      >
    </v-row>
    <data-table
      @updatePage="getData($event)"
      :headers="tableData.headers"
      :data="tableData.data"
      :editable="editAble"
      :deleteable="deleteAble"
      :loader="loader"
      :meta="pagination"
    />
  </div>
</template>
<script>
import { Grade } from "@/store/common/grade";
import { Subject } from "@/store/common/subject";
import dataTable from "@/components/mycomponent/base/dataTable.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import deletePopup from "@/pages/Dashboard/age-group/delete.vue";
export default {
  components: {
    dataTable,
    create,
    edit,
    deletePopup,
  },
  data() {
    return {
      Grade,
      Subject,
      createDialog: false,
      editDialog: false,
      dialogData: null,
      deleteDialog: false,
      deleteDialogData: null,
      schoolItems: [],
    };
  },
  methods: {
    getData(page) {
      let params = {
        page: page,
      };
      Subject.get(params);
      this.dialog = false;
    },
    async getSchoolIems(params) {
      await Grade.get(params);
      this.schoolItems = this.schoolItems.concat(this.shcoolData);
    },

    //create
    createAble() {
      this.createDialog = true;
    },
    async create(data) {
      await Subject.post(data);
      this.createDialog = false;
    },

    //edit
    async editAble(obj) {
      this.editDialog = true;
      await Subject.show(obj.id);
      this.dialogData = Subject.tableData.showData;
    },
    async edit(data) {
      await Subject.edit(data.data, data.id);
      this.editDialog = false;
    },

    //delete
    deleteAble(obj) {
      this.deleteDialog = true;
      this.deleteDialogData = obj;
    },
    async deleteItem(id) {
      await Subject.deleteItem(id);
      this.deleteDialog = false;
    },
  },
  computed: {
    //data
    tableData() {
      return Subject.tableData;
    },
    shcoolData() {
      return Grade.tableData.data;
    },
    pagination() {
      return Subject.tableData.meta;
    },
    //loaders
    loader() {
      return Subject.getState.loading;
    },
    createLoader() {
      return Subject.postState.loading;
    },
    editLoader() {
      return Subject.editState.loading;
    },
    showLoader() {
      return Subject.showState.loading;
    },
    deleteLoader() {
      return Subject.deleteState.loading;
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>
